import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useUserType } from '../../contexts/UserTypeContext';
import { useAuth } from '../../contexts/AuthContext';

const MyPage: React.FC = () => {
  const { currentUser } = useAuth();
  const { currentType } = useUserType();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (currentUser && !location.pathname.includes(currentType)) {
      navigate(`/mypage/${currentType}`, { replace: true });
    }
  }, [currentType, currentUser, location.pathname, navigate]);

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: '/mypage' }} />;
  }

  // 이미 올바른 경로에 있다면 리다이렉션하지 않음
  if (location.pathname === `/mypage/${currentType}`) {
    return null;
  }

  return <Navigate to={`/mypage/${currentType}`} replace />;
};

export default MyPage; 